<template>
  <div class="card-container">
    <a-skeleton :loading="loading" active :paragraph="{rows: 5}" />
    <header v-if="!loading">
      <h2>{{businessInfo.businessName}}</h2>
      <img src="@/assets/images/tag-partner.png">
    </header>
    <main v-if="!loading">
      <div class="key-btn-container">
        <span><show-appkey></show-appkey></span>
        <span @click="openApi">API文档</span>
          <span v-if="!expiresStatus" class="expires-time">{{expiresTime}}</span>
          <span v-if="expiresStatus" class="expires-time-red">{{expiresTime}}</span>
      </div>
      <div class="line-item">
        <span style="margin-right: 32px">商家ID：<label>{{businessInfo.businessId}}</label></span>
        <span style="margin-right: 32px">供应商编码：<label>{{businessInfo.supplierCode}}</label></span>
        <span v-if="!isBuzzType11" style="margin-right: 32px">违规扣分：<label class="amount">{{remind.commonBillScore ? remind.commonBillScore : 0}}</label></span>
      </div>
      <div class="line-item" v-if="!isBuzzType11">
        <span>店铺ID：<label>{{businessInfo.shopInfo | formatShopID}}</label></span>
      </div>
      <div class="line-item" v-if="!isBuzzType11">
        <span>店铺名称：<label>{{businessInfo.shopInfo | formatShopName}}</label></span>
      </div>
      <div class="line-item" v-if="!isBuzzType11">
        <span>K币余额：<label class="amount">{{businessInfo.amount | formatAmount}}</label></span>
      </div>
    
    </main>
    <a-button v-if="!isBuzzType11 && !loading" type="primary" class="recharge-btn" @click="gotoRecharge">去充值</a-button>
  </div>
</template>
<script>
  import ShowAppKey from '@/views/home/common/show-appkey'
  import { mapState, mapActions } from 'vuex'
  import { Skeleton, Button } from 'ant-design-vue'
  import _ from 'lodash'
  export default {
    name: 'partner-info',
    components: {
      [ShowAppKey.name]: ShowAppKey,
      [Skeleton.name]: Skeleton,
      [Button.name]: Button
    },
    data() {
      return {
        businessInfo: {},
        loading: true
      }
    },
    computed:{
      ...mapState(['cmsConfig']),
      ...mapState('popHome',['expiresTime', 'expiresStatus', 'remind']),
      isBuzzType11() {
        return +this.$cookie.get('buzzType') === 11
      },
    },
    async created() {
      await this.getKeyExpiresTime()
      await this.$store.dispatch('popHome/getPrewardPunisRemind')
      const res = await this.$store.dispatch('partnerHome/queryPartnerBusinessInfo')
      if (res && +res.code === 1) {
        this.loading = false
        this.businessInfo = res.data
      }
    },
    filters: {
      formatAmount(v) {
        if (isNaN(v)) {
          return '-'
        } else {
          return (+v / 100).toFixed(2)
        }
      },
      formatShopID(v) {
        let shopId = _.get(v, 'shopId')
        if (!shopId) {
          return '暂未绑定（联系平台运营维护）'
        } else {
          return shopId
        }
      },
      formatShopName(v) {
        let shopName = _.get(v, 'shopName')
        if (!shopName) {
          return '暂未绑定（联系平台运营维护）'
        } else {
          return shopName
        }
      }
    },
    methods: {
      ...mapActions('popHome',[
      'getKeyExpiresTime'
    ]),
      openApi () {
        window.open(this.cmsConfig.apiUrl)
      },
      gotoRecharge() {
        const PROTOCOL = process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'
        const RECHARGE_URL = `${PROTOCOL}://open.haiziwang.com/platform/?link=${PROTOCOL}://ad.haiziwang.com/pure/account/x/addCredit/add/outside&hide=true`
        window.open(RECHARGE_URL)
      },
    }
  }
</script>
<style scoped lang="scss">
  .card-container {
    background: #FFFFFF;
    height: 100%;
    padding: 20px;
  }
  header {
    display: flex;
    justify-items: center;
    h2 {
      font-size: 16px;
      font-family: MicrosoftYaHei, PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 20px;
      margin-right: 10px;
    }
    img {
      height: 18px;
    }
  }
  .key-btn-container {
    margin-top: 18px;
    a, span {
      color: #1C7AE5;
      cursor: pointer;
      margin-right: 20px;
    };
    .expires-time {
       color: #333333;
    }
     .expires-time-red {
      color: #FF6770;
    }
  }
  .line-item {
    margin-top: 12px;
    color: #333333;
    label {
      color: #000000;
    }
    label.amount {
      color: #1C7AE5;
      font-weight: 500;
    }
  }
  .recharge-btn {
    width: 82px;
    height: 28px;
    border-radius: 3px;
    margin-top: 18px;
  }
</style>
